import { SiteSurvey } from "api/types/siteSurvey";

export function getEmptyUnit(survey: SiteSurvey) {
  const emptyUnit = {
    attributes: [],
    id: -1,
    modelNumber: "",
    photos: [],
    rtu: `${survey.units.length + 1}`,
    serialNumber: "",
  };
  return emptyUnit;
}
